export default "__VITE_ASSET__BDRg9I14__"